export enum DealResponseCodes {
  EXPIRED_DEAL = 400401,
  DEALER_NOT_FOUND = 404300,
}
